var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.99976H14M18 11.9998H14M12 15.4998C11.7164 14.3586 10.481 13.4998 9 13.4998C7.519 13.4998 6.28364 14.3586 6 15.4998M6.2 18.9998H17.8C18.9201 18.9998 19.4802 18.9998 19.908 18.7818C20.2843 18.59 20.5903 18.2841 20.782 17.9077C21 17.4799 21 16.9199 21 15.7998V8.19976C21 7.07965 21 6.5196 20.782 6.09177C20.5903 5.71545 20.2843 5.40949 19.908 5.21774C19.4802 4.99976 18.9201 4.99976 17.8 4.99976H6.2C5.0799 4.99976 4.51984 4.99976 4.09202 5.21774C3.71569 5.40949 3.40973 5.71545 3.21799 6.09177C3 6.5196 3 7.07965 3 8.19976V15.7998C3 16.9199 3 17.4799 3.21799 17.9077C3.40973 18.2841 3.71569 18.59 4.09202 18.7818C4.51984 18.9998 5.07989 18.9998 6.2 18.9998ZM10 9.49976C10 10.052 9.55228 10.4998 9 10.4998C8.44772 10.4998 8 10.052 8 9.49976C8 8.94747 8.44772 8.49976 9 8.49976C9.55228 8.49976 10 8.94747 10 9.49976Z",
    stroke: "#1E73FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressCard);
export default __webpack_public_path__ + "static/media/addressCard.73a0b43b63f89a7acc6814cc2a8c1e1b.svg";
export { ForwardRef as ReactComponent };